import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import GallerySection from '../components/GallerySection'
import { useCmsPage } from '../hooks/useCmsPage'

export default function FestTyperPage() {
  const { page } = useCmsPage('fest-typer')

  const title = page?.meta_title || 'DJ til festen — Casper DJ'
  const description =
    page?.meta_description ||
    'CasperDJ kan blive din DJ til festen! Jeg bringer musik og sætter gang i dansegulvet til både firmafester, privatfester og bryllupsfester! Kontakt mig allerede idag, for mere info!, CasperDJ kan blive din DJ til festen! Jeg bringer musik og sætter gang i dansegulvet til både firmafester, privatfester og bryllupsfester! Kontakt mig allerede idag, for mere info!'

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-48 md:pb-24 border-b border-neutral-900 bg-neutral-900/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                Musik &amp; Underholdning
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight">
                EN DJ MED ERFARING
              </h1>
              <p className="text-base sm:text-lg text-neutral-300 leading-relaxed">
                CasperDJ kan blive din DJ til festen. Jeg bringer musik og sætter gang i dansegulvet til både firmafester, privatfester og bryllupsfester! Jeg spiller i hele Danmark, og uanset anledningen bringer jeg lyden af uforglemmelige øjeblikke. Med min kærlighed til musik og års erfaring står jeg klar som den ideelle DJ til at skabe den gode lyd til din begivenhed.
              </p>
              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-gold-400 text-neutral-950 font-bold text-sm uppercase tracking-wider rounded-xl hover:bg-gold-300 transition-colors shadow-lg cursor-pointer"
                >
                  Kontakt mig
                </Link>
                <Link
                  to="/faa-et-tilbud"
                  className="px-6 py-3.5 border border-neutral-800 bg-neutral-900 text-white font-bold text-sm uppercase tracking-wider rounded-xl hover:border-gold-400/50 hover:text-gold-400 transition-colors cursor-pointer"
                >
                  Få et tilbud
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="relative aspect-video lg:aspect-[4/3] rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/selects-00-33-10-15-still012.jpg"
                  alt="Casper DJ setup til fest"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Categories Section */}
      <section className="py-20 md:py-28 bg-neutral-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-14">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
              Vælg din kategori
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mt-1">
              Musik til
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* FIRMAFEST */}
            <div className="rounded-3xl bg-neutral-900/40 border border-neutral-800/80 overflow-hidden flex flex-col justify-between hover:border-gold-400/40 transition-colors">
              <div className="aspect-[4/3] w-full overflow-hidden bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/koldt.png"
                  alt="Firmafest"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6 sm:p-8 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-white uppercase tracking-wider">
                    FIRMAFEST
                  </h3>
                  <p className="text-neutral-300 text-sm mt-3 leading-relaxed">
                    En god firmafest er en positiv samlende oplevelse, og som dj til firmafesten, så sikrer CasperDJ at festen bliver, som I ønsker den. Vi kan tilpasse musik og setup til alle former for arrangementer: små og store virksomheder, hyggelige julefrokoster og uforglemmelige sommerfest-brag.
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-neutral-800">
                  <Link
                    to="/firmafest"
                    className="inline-flex items-center gap-2 text-xs font-bold text-gold-400 uppercase tracking-wider hover:text-gold-300 transition-colors"
                  >
                    <span>Læs mere</span>
                    <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>

            {/* PRIVATFEST */}
            <div className="rounded-3xl bg-neutral-900/40 border border-neutral-800/80 overflow-hidden flex flex-col justify-between hover:border-gold-400/40 transition-colors">
              <div className="aspect-[4/3] w-full overflow-hidden bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/img-8471.jpg"
                  alt="Privatfest"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6 sm:p-8 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-white uppercase tracking-wider">
                    PRIVATFEST
                  </h3>
                  <p className="text-neutral-300 text-sm mt-3 leading-relaxed">
                    Middag for de nærmeste, konfirmationsfest i baghaven, rund fødselsdag i forsamlingshuset eller bryllup på slottet?
                    <br /><br />
                    Hos CasperDJ har vi professionelt udstyr til ethvert set-up, stort som småt.
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-neutral-800">
                  <Link
                    to="/privatfest"
                    className="inline-flex items-center gap-2 text-xs font-bold text-gold-400 uppercase tracking-wider hover:text-gold-300 transition-colors"
                  >
                    <span>Læs mere</span>
                    <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>

            {/* BRYLLUP */}
            <div className="rounded-3xl bg-neutral-900/40 border border-neutral-800/80 overflow-hidden flex flex-col justify-between hover:border-gold-400/40 transition-colors">
              <div className="aspect-[4/3] w-full overflow-hidden bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/img-0003.jpg"
                  alt="Bryllup"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6 sm:p-8 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-white uppercase tracking-wider">
                    BRYLLUP
                  </h3>
                  <p className="text-neutral-300 text-sm mt-3 leading-relaxed">
                    Et bryllup er én af livets største begivenheder, og det kan ikke gøres om. Uanset om planen er en intim lille fejring eller et overdådigt slotsbryllup er det rette musikvalg og en professionel eksekvering afgørende for stemningen.
                    <br /><br />
                    Det ansvar tager vi stolt på os hos CasperDJ, som dj til brylluppet.
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-neutral-800">
                  <Link
                    to="/bryllup"
                    className="inline-flex items-center gap-2 text-xs font-bold text-gold-400 uppercase tracking-wider hover:text-gold-300 transition-colors"
                  >
                    <span>Læs mere</span>
                    <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature bullets section */}
      <section className="py-20 md:py-28 bg-neutral-900/30 border-y border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5">
              <div className="relative aspect-[3/4] rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/image-asset.jpeg"
                  alt="DJ stemning"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                Oplevelser, der går ud over musikken
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-tight">
                Dj til festen - Oplevelser, der går ud over musikken
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
                <div className="p-5 rounded-2xl bg-neutral-950/80 border border-neutral-800/80">
                  <h4 className="text-base font-bold text-gold-400 flex items-center gap-2">
                    <i className="fa-solid fa-sliders text-xs" aria-hidden="true" />
                    <span>Musikvalg</span>
                  </h4>
                  <p className="text-sm text-neutral-300 mt-2 leading-relaxed">
                    Mit brede udvalg af musikgenrer giver dig mulighed for at tilpasse lydbilledet til din begivenheds karakter. Fra klassiske hits til de nyeste trends – jeg har det hele.
                  </p>
                </div>

                <div className="p-5 rounded-2xl bg-neutral-950/80 border border-neutral-800/80">
                  <h4 className="text-base font-bold text-gold-400 flex items-center gap-2">
                    <i className="fa-solid fa-wave-square text-xs" aria-hidden="true" />
                    <span>Mix og Overgange</span>
                  </h4>
                  <p className="text-sm text-neutral-300 mt-2 leading-relaxed">
                    Min evne til at skabe sømløse musik overgange og mix bringer en kontinuerlig og energisk stemning til festen. Der vil ikke være et kedeligt øjeblik.
                  </p>
                </div>

                <div className="p-5 rounded-2xl bg-neutral-950/80 border border-neutral-800/80">
                  <h4 className="text-base font-bold text-gold-400 flex items-center gap-2">
                    <i className="fa-solid fa-microphone-lines text-xs" aria-hidden="true" />
                    <span>Interaktion</span>
                  </h4>
                  <p className="text-sm text-neutral-300 mt-2 leading-relaxed">
                    Som din DJ interagerer jeg med publikum og tilpasser musikken efter deres stemning.
                  </p>
                </div>

                <div className="p-5 rounded-2xl bg-neutral-950/80 border border-neutral-800/80">
                  <h4 className="text-base font-bold text-gold-400 flex items-center gap-2">
                    <i className="fa-solid fa-headphones text-xs" aria-hidden="true" />
                    <span>Ønsker og anmodninger</span>
                  </h4>
                  <p className="text-sm text-neutral-300 mt-2 leading-relaxed">
                    Jeg lytter til dine ønsker og anmodninger for at skræddersy musikprogrammet efter din smag og dine gæsters præferencer.
                  </p>
                </div>
              </div>

              {/* Bottom callout banner */}
              <div className="p-6 rounded-2xl bg-neutral-950 border border-neutral-800 mt-6 space-y-2">
                <h3 className="text-lg font-bold text-white uppercase tracking-wider">
                  Én DJ - Ét Navn – Én Oplevelse for Livet.
                </h3>
                <p className="text-sm text-neutral-300">
                  <Link to="/kontakt" className="text-gold-400 font-semibold hover:underline">
                    Kontakt mig
                  </Link>{' '}
                  i dag for at drøfte, hvordan CasperDJ din Dj til festen kan tilføje en ekstra dimension til din begivenhed.
                </p>
                <p className="text-xs text-neutral-400">
                  Selvom jeg er baseret i Odense, er jeg til rådighed for arrangementer i hele Danmark efter aftale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection
        gallerySlug="galleri-billeder"
        title="Billeder fra fester i hele Danmark"
        subtitle="Oplev den fantastiske stemning fra dansegulvet."
      />
    </div>
  )
}
